import React, { useMemo, useRef, useState, useEffect } from 'react';
import { adminAPI, planAPI, subscriptionAPI, userAPI ,updatePaymentInfo } from '../services/api';
import './AdminPanel.css';
import debounce from 'lodash.debounce';

function AdminPanel() {
    // State for delete confirmation modal
    const [paymentData, setPaymentData] = useState({});
const [paymentForm, setPaymentForm] = useState({
  date: '',
  note: ''
});
    const [selectedPaymentUser, setSelectedPaymentUser] = useState(null);
    const [paidUsers, setPaidUsers] = useState({});
    const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [isSessionsModalOpen, setIsSessionsModalOpen] = useState(false);
  const [sessionDetailModal, setSessionDetailModal] = useState(null);
  const [users, setUsers] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    user_id: '',
    plan_id: '',
    duration_months: '1',
  });
  const [planForm, setPlanForm] = useState({
    name: '',
    monthly_price: '',
    description: '',
  });
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [showSubscriptionFormForUserId, setShowSubscriptionFormForUserId] = useState(null);
  const [message, setMessage] = useState('');
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [deleteUserDialog, setDeleteUserDialog] = useState(null);
  const [resetPasswordDialog, setResetPasswordDialog] = useState(null);
  const [newUser, setNewUser] = useState({
    name: '',
    phone: '',
    email: '',
    password: ''
  });
  const [addUserMessage, setAddUserMessage] = useState('');
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const [debouncedUserSearchQuery, setDebouncedUserSearchQuery] = useState('');
  const [subscriptionFilter, setSubscriptionFilter] = useState('all');
  const [kpis, setKpis] = useState({
    active_users: 0,
    expiring_in_7_days: 0,
    mrr: 0,
    cancelled_this_month: 0,
    new_users_30_days: 0,
  });
    // Reported issues modal state
    const [reportedIssues, setReportedIssues] = useState([]);
    const [reportedIssuesLoading, setReportedIssuesLoading] = useState(false);
    const [isReportedIssuesModalOpen, setIsReportedIssuesModalOpen] = useState(false);
    useEffect(() => {
      const handler = () => setIsReportedIssuesModalOpen(true);
      window.addEventListener('openReportedIssues', handler);
      return () => window.removeEventListener('openReportedIssues', handler);
    }, []);
    useEffect(() => {
      const fetchReportedIssues = async () => {
        setReportedIssuesLoading(true);
        try {
          const res = await adminAPI.getReportedIssues();
          setReportedIssues(res.data);
        } catch (err) {
          setReportedIssues([]);
        } finally {
          setReportedIssuesLoading(false);
        }
      };
      fetchReportedIssues();
    }, []);
    // Delete report handler
    const handleDeleteReport = async (id) => {
      try {
        await adminAPI.deleteReportedIssue(id);
        setReportedIssues(reportedIssues.filter(issue => issue.id !== id));
        setDeleteConfirmId(null);
      } catch (err) {
        alert('Грешка при бришење на проблемот.');
      }
    };

    // Modal for reported issues
    const ReportedIssuesModal = () => (
      <div className="admin-modal-overlay" onClick={() => setIsReportedIssuesModalOpen(false)}>
        <div className="admin-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px', width: '90vw', padding: '32px', borderRadius: '16px', background: '#fff', boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}>
          <h2 style={{ marginBottom: 24, fontWeight: 700, fontSize: '2rem', textAlign: 'center' }}>Пријавени проблеми од корисници</h2>
          {reportedIssuesLoading ? (
            <div style={{ textAlign: 'center', padding: '24px' }}>Се вчитуваат проблемите...</div>
          ) : reportedIssues.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '24px' }}>Нема пријавени проблеми.</div>
          ) : (
            <div style={{ maxHeight: '60vh', overflowY: 'auto', marginBottom: 24 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, fontSize: '1rem' }}>
                <thead>
                  <tr style={{ background: '#e0e0e0' }}>
                    <th style={{ padding: '12px', borderRadius: '8px 0 0 8px', textAlign: 'left' }}>Корисник</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Е-пошта</th>
                    <th style={{ padding: '12px', textAlign: 'left', minWidth: 300 }}>Порака</th>
                    <th style={{ padding: '12px', textAlign: 'left' }}>Време</th>
                    <th style={{ padding: '12px', borderRadius: '0 8px 8px 0', textAlign: 'center' }}>Избриши</th>
                  </tr>
                </thead>
                <tbody>
                  {reportedIssues.map(issue => (
                    <tr key={issue.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '12px', fontWeight: 500 }}>{issue.user_name}</td>
                      <td style={{ padding: '12px' }}>{issue.user_email}</td>
                      <td style={{ padding: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', background: '#fafafa', borderRadius: 6 }}>{issue.message}</td>
                      <td style={{ padding: '12px', color: '#888' }}>{new Date(issue.created_at).toLocaleString()}</td>
                      <td style={{ padding: '12px', textAlign: 'center' }}>
                        <button className="btn-subscription" style={{ background: '#e74c3c', color: '#fff', borderRadius: 6, padding: '6px 16px', fontSize: '0.95rem' }} onClick={() => setDeleteConfirmId(issue.id)}>Избриши</button>
                                {/* Delete confirmation modal */}
                                {deleteConfirmId !== null && (
                                  <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', padding: '32px', minWidth: 320, maxWidth: 400, textAlign: 'center' }}>
                                      <h3 style={{ marginBottom: 18 }}>Избриши проблем?</h3>
                                      <p style={{ marginBottom: 24 }}>Дали сте сигурни дека сакате да го избришете овој проблем?</p>
                                      <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
                                        <button className="btn-subscription" style={{ background: '#e74c3c', color: '#fff', borderRadius: 6, padding: '8px 24px', fontSize: '1rem' }} onClick={() => handleDeleteReport(deleteConfirmId)}>Избриши</button>
                                        <button className="btn-subscription" style={{ background: '#eee', color: '#333', borderRadius: 6, padding: '8px 24px', fontSize: '1rem' }} onClick={() => setDeleteConfirmId(null)}>Откажи</button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <button className="btn-subscription" style={{ margin: '0 auto', display: 'block', padding: '12px 32px', fontSize: '1.1rem', borderRadius: 8 }} onClick={() => setIsReportedIssuesModalOpen(false)}>Затвори</button>
        </div>
      </div>
    );
  const [userInsights, setUserInsights] = useState([]);
  const [isInsightsModalOpen, setIsInsightsModalOpen] = useState(false);
  const [insightDetailModal, setInsightDetailModal] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [sessionFilters, setSessionFilters] = useState({ user_id: '', status: 'active' });
  const [activeTab, setActiveTab] = useState('users');
  const sessionFiltersRef = useRef(sessionFilters);

  useEffect(() => {
    sessionFiltersRef.current = sessionFilters;
  }, [sessionFilters]);

  const handleToggleMonthlyReport = async (userId, currentValue) => {
    try {
      await userAPI.toggleMonthlyReport(userId, !currentValue);
      setMessage('✓ Пристапот до месечен извештај е ажуриран');
      fetchAdminData({ showLoader: false });
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error toggling monthly report:', error);
      setMessage('Грешка при ажурирање на пристап до месечен извештај');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    try {
      // Ensure all required fields are sent
      const payload = {
        name: newUser.name,
        phone: newUser.phone,
        email: newUser.email,
        password: newUser.password
      };
      const response = await userAPI.createUser(payload);
      if (response.status === 201 || response.status === 200) {
        setAddUserMessage('Корисникот е успешно додаден!');
        setNewUser({ name: '', shop_name: '', phone: '', email: '', password: '' });
        fetchAdminData({ showLoader: false });
      } else {
        setAddUserMessage('Неуспешно додавање на корисник.');
      }
    } catch (error) {
      setAddUserMessage('Грешка при додавање на корисник.');
    }
    setTimeout(() => setAddUserMessage(''), 3000);
  };

  useEffect(() => {
  const refreshLiveData = async (showLoader = false) => {
    await Promise.all([
      fetchAdminData({ showLoader }),
      fetchDashboardKpis(),
      fetchUserInsights(),
      fetchSessions(sessionFiltersRef.current),
    ]);
  };

  refreshLiveData(true);
}, []);

  useEffect(() => {
    fetchSessions(sessionFilters);
  }, [sessionFilters]);

  const fetchAdminData = async ({ showLoader = false } = {}) => {
    try {
      if (showLoader) {
        setLoading(true);
      }

      const [usersResponse, subscriptionsResponse, plansResponse] = await Promise.all([
        userAPI.getAdminAllUsers(),
        subscriptionAPI.getAllSubscriptions(),
        planAPI.getAllPlans(),
      ]);

      setUsers(usersResponse.data || []);
      setSubscriptions(subscriptionsResponse.data || []);
      setPlans(plansResponse.data || []);
    } catch (error) {
      console.error('Error fetching admin data:', error);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  const fetchDashboardKpis = async () => {
    try {
      const response = await adminAPI.getDashboardKpis();
      setKpis(response.data || {});
    } catch (error) {
      console.error('Error fetching dashboard KPIs:', error);
    }
  };

  const fetchUserInsights = async () => {
    try {
      const response = await adminAPI.getUserInsights();
      setUserInsights(response.data || []);
    } catch (error) {
      console.error('Error fetching user insights:', error);
    }
  };

  const renderDeltaBadge = (value) => {
    const numericValue = Number(value || 0);

    if (numericValue > 0) {
      return <span className="delta-badge delta-positive">+{numericValue}</span>;
    }

    if (numericValue < 0) {
      return <span className="delta-badge delta-negative">{numericValue}</span>;
    }

    return <span className="delta-badge delta-neutral">0</span>;
  };

  const renderCurrencyDeltaBadge = (value) => {
    const numericValue = Number(value || 0);

    if (numericValue > 0) {
      return <span className="delta-badge delta-positive">+{numericValue.toFixed(2)}</span>;
    }

    if (numericValue < 0) {
      return <span className="delta-badge delta-negative">{numericValue.toFixed(2)}</span>;
    }

    return <span className="delta-badge delta-neutral">0.00</span>;
  };

  const openInsightDetailModal = ({ type, userName, items }) => {
    setInsightDetailModal({
      type,
      userName,
      items: Array.isArray(items) ? items : [],
    });
  };

  const fetchSessions = async (filters = sessionFilters) => {
    try {
      const params = {};
      if (filters.user_id) params.user_id = filters.user_id;
      if (filters.status) params.status = filters.status;

      const response = await adminAPI.getSessions(params);
      setSessions(response.data || []);
    } catch (error) {
      console.error('Error fetching sessions:', error);
    }
  };

  const handleRevokeSession = async (sessionId) => {
    if (!window.confirm('Дали сте сигурни дека сакате да ја одјавите оваа сесија?')) return;
    try {
      await adminAPI.revokeSession(sessionId);
      setMessage('✓ Сесијата е успешно одјавена');
      await fetchSessions(); // Refresh session list after revocation
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error revoking session:', error);
      setMessage(error.response?.data?.error || 'Грешка при одјавување на сесија');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const getLatestSubscriptionForUser = (userId) => {
    const userSubscriptions = subscriptions.filter((subscription) => Number(subscription.user_id) === Number(userId));

    if (userSubscriptions.length === 0) {
      return null;
    }

    return [...userSubscriptions].sort((a, b) => {
      const aUpdated = new Date(a.updated_at || a.created_at || 0).getTime();
      const bUpdated = new Date(b.updated_at || b.created_at || 0).getTime();

      if (bUpdated !== aUpdated) {
        return bUpdated - aUpdated;
      }

      return Number(b.id || 0) - Number(a.id || 0);
    })[0];
  };

  const handleOpenSubscriptionForm = (userId) => {
    const firstActivePlan = plans.find((plan) => plan.is_active) || plans[0];

    setShowSubscriptionFormForUserId(userId);
    setFormData({
      user_id: userId,
      plan_id: firstActivePlan ? String(firstActivePlan.id) : '',
      duration_months: '1',
    });
  };

  const handleSubmitPlan = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        name: planForm.name,
        monthly_price: Number(planForm.monthly_price),
        description: planForm.description || null,
      };

      if (editingPlanId) {
        await planAPI.updatePlan(editingPlanId, payload);
        setMessage('✓ Планот е ажуриран');
      } else {
        await planAPI.createPlan(payload);
        setMessage('✓ Планот е креиран');
      }

      setPlanForm({ name: '', monthly_price: '', description: '' });
      setEditingPlanId(null);
      await fetchAdminData({ showLoader: false });
    } catch (error) {
      console.error('Error saving plan:', error);
      setMessage(error.response?.data?.error || 'Грешка при зачувување на план');
    } finally {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleEditPlan = (plan) => {
    setEditingPlanId(plan.id);
    setPlanForm({
      name: plan.name || '',
      monthly_price: String(plan.monthly_price ?? ''),
      description: plan.description || '',
    });
  };

  const handleTogglePlanActive = async (plan) => {
    try {
      await planAPI.updatePlan(plan.id, { is_active: !plan.is_active });
      setMessage('✓ Статусот на планот е ажуриран');
      await fetchAdminData({ showLoader: false });
    } catch (error) {
      console.error('Error toggling plan status:', error);
      setMessage('Грешка при ажурирање на план');
    } finally {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const resolveBookingBaseUrl = () => {
    const configuredBaseUrl = (process.env.REACT_APP_BOOKING_BASE_URL || 'http://localhost:3002').replace(/\/$/, '');

    try {
      const parsedUrl = new URL(configuredBaseUrl);
      const isLocalHost = parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1';
      const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
      const runtimeIsRemote = runtimeHost && runtimeHost !== 'localhost' && runtimeHost !== '127.0.0.1';

      if (isLocalHost && runtimeIsRemote) {
        parsedUrl.hostname = runtimeHost;
        return parsedUrl.toString().replace(/\/$/, '');
      }

      return configuredBaseUrl;
    } catch (error) {
      return configuredBaseUrl;
    }
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

            {/* Reported Issues Section */}
            <section className="reported-issues-section" style={{ margin: '32px 0', padding: '24px', background: '#f9f9f9', borderRadius: 12, boxShadow: '0 2px 8px #e0e0e0' }}>
              <h2 style={{ marginBottom: 18 }}>Пријавени проблеми од корисници</h2>
              {reportedIssuesLoading ? (
                <div>Се вчитуваат проблемите...</div>
              ) : reportedIssues.length === 0 ? (
                <div>Нема пријавени проблеми.</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8 }}>
                  <thead>
                    <tr style={{ background: '#e0e0e0' }}>
                      <th style={{ padding: '10px', borderRadius: '8px 0 0 8px' }}>Корисник</th>
                      <th style={{ padding: '10px' }}>Е-пошта</th>
                      <th style={{ padding: '10px' }}>Порака</th>
                      <th style={{ padding: '10px', borderRadius: '0 8px 8px 0' }}>Време</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportedIssues.map(issue => (
                      <tr key={issue.id} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: '10px' }}>{issue.user_name}</td>
                        <td style={{ padding: '10px' }}>{issue.user_email}</td>
                        <td style={{ padding: '10px', maxWidth: 320, wordBreak: 'break-word' }}>{issue.message}</td>
                        <td style={{ padding: '10px', color: '#888' }}>{new Date(issue.created_at).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </section>
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const copied = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (!copied) {
      throw new Error('Clipboard copy not supported on this device/browser');
    }
  };

  const getBookingLink = (user) => {
    const bookingBaseUrl = resolveBookingBaseUrl();

    if (user.booking_token) {
      return `${bookingBaseUrl}/?provider=${user.booking_token}`;
    }

    return `${bookingBaseUrl}/?userId=${user.id}`;
  };

  const copyBookingLink = async (user) => {
    const link = getBookingLink(user);

    try {
      await copyTextToClipboard(link);
      setMessage('✓ Линкот е копиран!');
    } catch (error) {
      console.error('Error copying link:', error);
      setMessage('Не може автоматски да се копира. Задржете за копирање: ' + link);
    }

    setTimeout(() => setMessage(''), 5000);
  };

  const handleCreateSubscription = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        user_id: Number(formData.user_id),
        plan_id: Number(formData.plan_id),
        duration_months: Number(formData.duration_months),
      };

      await subscriptionAPI.createSubscription(payload);
      setFormData({
        user_id: '',
        plan_id: '',
        duration_months: '1',
      });
      setShowSubscriptionFormForUserId(null);
      setMessage('✓ Претплатата е креирана');
      await fetchAdminData({ showLoader: false });
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error creating subscription:', error);
      setMessage('Грешка при креирање претплата');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleSubscriptionLifecycleAction = async (subscriptionId, action) => {
    try {
      await subscriptionAPI.updateLifecycle(subscriptionId, action);
      setMessage('✓ Претплатата е ажурирана');
      await fetchAdminData({ showLoader: false });
    } catch (error) {
      console.error('Error updating subscription lifecycle:', error);
      setMessage('Грешка при ажурирање на претплатата');
    } finally {
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const openLifecycleConfirm = (subscriptionId, action) => {
    const actionLabel = action === 'cancel' ? 'откажете' : 'паузирате';
    setConfirmDialog({
      subscriptionId,
      action,
      title: 'Потврда за акција',
      description: `Дали сте сигурни дека сакате да ја ${actionLabel} претплатата?`,
    });
  };

  const closeLifecycleConfirm = () => {
    setConfirmDialog(null);
  };

  const handleConfirmLifecycle = async () => {
    if (!confirmDialog) return;

    await handleSubscriptionLifecycleAction(confirmDialog.subscriptionId, confirmDialog.action);
    closeLifecycleConfirm();
  };

  const openDeleteUserConfirm = (user) => {
    setDeleteUserDialog(user);
  };

  const closeDeleteUserConfirm = () => {
    setDeleteUserDialog(null);
  };

  const handleConfirmDeleteUser = async () => {
    if (!deleteUserDialog) {
      return;
    }

    try {
      const response = await userAPI.deleteUser(deleteUserDialog.id);
      console.log('Delete response:', response);
      await fetchAdminData({ showLoader: false });
      setMessage('✓ Корисникот е избришан');
    } catch (err) {
      console.error('Delete error details:', err);
      console.error('Full error response:', err.response);
      const errorMsg = err.response?.data?.error || err.message || 'Неуспешно бришење на корисник';
      setMessage(`Грешка: ${errorMsg}`);
    } finally {
      closeDeleteUserConfirm();
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const openResetPasswordConfirm = (user) => {
    setResetPasswordDialog(user);
  };

  const closeResetPasswordConfirm = () => {
    setResetPasswordDialog(null);
  };

  const handleConfirmResetPassword = async () => {
    if (!resetPasswordDialog) {
      return;
    }

    try {
      await userAPI.resetUserPassword(resetPasswordDialog.id);
      setMessage(`✓ Лозинката за ${resetPasswordDialog.name} е ресетирана на 12345`);
    } catch (error) {
      console.error('Error resetting user password:', error);
      setMessage(error.response?.data?.error || 'Грешка при ресетирање лозинка');
    } finally {
      closeResetPasswordConfirm();
      setTimeout(() => setMessage(''), 4000);
    }
  };

  const renderSubscriptionCell = (user, latestSubscriptionOverride = null) => {
    const latestSubscription = latestSubscriptionOverride || getLatestSubscriptionForUser(user.id);

    const renderInlineSubscriptionForm = () => (
      <form className="subscription-inline-form" onSubmit={handleCreateSubscription}>
        <select
          value={formData.plan_id}
          onChange={(e) => setFormData({ ...formData, plan_id: e.target.value })}
          required
        >
          <option value="">Избери план</option>
          {plans.filter((plan) => plan.is_active).map((plan) => (
            <option key={plan.id} value={plan.id}>
              {plan.name} - {Number(plan.monthly_price || 0).toFixed(2)} MKD / месец
            </option>
          ))}
        </select>
        <input
          type="number"
          min="1"
          value={formData.duration_months}
          onChange={(e) => setFormData({ ...formData, duration_months: e.target.value })}
          placeholder="Месеци"
          required
        />
        <div className="subscription-inline-actions">
          <button type="submit" className="btn-subscription btn-subscription-create">Креирај</button>
          <button type="button" className="btn-subscription" onClick={() => setShowSubscriptionFormForUserId(null)}>Откажи</button>
        </div>
      </form>
    );

    if (!latestSubscription) {
      return (
        <div className="subscription-cell">
          <p className="subscription-empty">Нема активна претплата</p>
          {showSubscriptionFormForUserId === user.id ? (
            renderInlineSubscriptionForm()
          ) : (
            <button
              type="button"
              className="btn-subscription btn-subscription-create"
              onClick={() => handleOpenSubscriptionForm(user.id)}
            >
              Нова претплата
            </button>
          )}
        </div>
      );
    }

    const normalizedStatus = String(latestSubscription.status || '').toLowerCase();
    const now = new Date();
const endDate = latestSubscription.end_date ? new Date(latestSubscription.end_date) : null;
const diffDays = endDate ? (endDate - now) / (1000 * 60 * 60 * 24) : null;

let visualStatus = normalizedStatus;

if (normalizedStatus === 'active' && diffDays !== null) {
  if (diffDays < 0) visualStatus = 'overdue';
  else if (diffDays <= 3) visualStatus = 'expiring';
}
let expiryLabel = '-';

if (endDate && normalizedStatus === 'active') {
  const roundedDays = Math.ceil(diffDays);

  if (roundedDays < 0) {
    expiryLabel = `Истечено пред ${Math.abs(roundedDays)} дена`;
  } else if (roundedDays === 0) {
    expiryLabel = 'Истекува денес';
  } else if (roundedDays === 1) {
    expiryLabel = 'Истекува за 1 ден';
  } else {
    expiryLabel = `Истекува за ${roundedDays} дена`;
  }
} else if (endDate) {
  expiryLabel = `Важи до: ${new Date(latestSubscription.end_date).toLocaleDateString()}`;
}

    return (
      <div className="subscription-cell">
        <details className="subscription-details">
          <summary className="subscription-name-summary">{latestSubscription.plan_name}</summary>
          <div className="subscription-details-body">
            <p className="subscription-meta">{Number(latestSubscription.price || 0).toFixed(2)} MKD</p>
            <p className="subscription-meta">
              <span className={`subscription-status subscription-status-${visualStatus}`}>
  {visualStatus || '-'}
</span>
            </p>
            <p className="subscription-meta">
  {expiryLabel}
  {latestSubscription.end_date
    ? ` • ${new Date(latestSubscription.end_date).toLocaleDateString()}`
    : ''}
</p>
            {normalizedStatus === 'cancelled' && showSubscriptionFormForUserId === user.id && renderInlineSubscriptionForm()}
            <div className="subscription-action-row">
              {normalizedStatus === 'active' && (
                <>
                  <button type="button" className="btn-subscription" onClick={() => openLifecycleConfirm(latestSubscription.id, 'pause')}>Пауза</button>
                  <button type="button" className="btn-subscription btn-subscription-danger" onClick={() => openLifecycleConfirm(latestSubscription.id, 'cancel')}>Откажи</button>
                </>
              )}
              {normalizedStatus === 'paused' && (
                <>
                  <button type="button" className="btn-subscription btn-subscription-resume" onClick={() => handleSubscriptionLifecycleAction(latestSubscription.id, 'resume')}>Продолжи</button>
                  <button type="button" className="btn-subscription btn-subscription-danger" onClick={() => openLifecycleConfirm(latestSubscription.id, 'cancel')}>Откажи</button>
                </>
              )}
              {normalizedStatus === 'cancelled' && (
                <button type="button" className="btn-subscription btn-subscription-create" onClick={() => handleOpenSubscriptionForm(user.id)}>Нова претплата</button>
              )}
            </div>
          </div>
        </details>
      </div>
    );
  };

  const displayedUsers = useMemo(() => {
    const normalizedQuery = userSearchQuery.trim().toLowerCase();

    return users
      .filter((user) => user.role !== 'admin')
      .map((user) => ({
        ...user,
        latestSubscription: getLatestSubscriptionForUser(user.id),
      }))
      .filter((user) => {
        if (!normalizedQuery) return true;
        const searchTarget = `${user.id} ${user.name || ''} ${user.email || ''} ${user.phone || ''}`.toLowerCase();
        return searchTarget.includes(normalizedQuery);
      })
      .filter((user) => {
        if (subscriptionFilter === 'all') return true;
        const status = String(user.latestSubscription?.status || 'none').toLowerCase();
        if (subscriptionFilter === 'none') return status === 'none';
        return status === subscriptionFilter;
      });
  }, [users, subscriptions, userSearchQuery, subscriptionFilter]);

  const openPaymentModal = (user) => {
  setSelectedPaymentUser(user);

  setPaymentForm({
    date: user.last_payment_date || '',
    note: user.payment_note || ''
  });
};

const closePaymentModal = () => {
  setSelectedPaymentUser(null);
  setPaymentForm({
    date: '',
    note: ''
  });
};

  if (loading) {
    return <div className="loading">Се вчитува...</div>;
  }

  return (
    <div className="admin-panel">
      <h1 style={{ margin: '32px 0 16px 0', fontWeight: 700, fontSize: '2.5rem', textAlign: 'left' }}>Админ панел</h1>
      {/* No top bar button, now handled in navbar */}
<div className="admin-panel-tabs">
  <button
    type="button"
    className={`admin-panel-tab ${activeTab === 'users' ? 'active' : ''}`}
    onClick={() => setActiveTab('users')}
  >
    Корисници
  </button>

  <button
    type="button"
    className={`admin-panel-tab ${activeTab === 'activity' ? 'active' : ''}`}
    onClick={() => setActiveTab('activity')}
  >
    Активност
  </button>

  <button
    type="button"
    className={`admin-panel-tab ${activeTab === 'sessions' ? 'active' : ''}`}
    onClick={() => setActiveTab('sessions')}
  >
    Сесии
  </button>
</div>
{activeTab === 'users' && (
      <div className="admin-kpi-grid">
        <div className="kpi-card"><p>Активни корисници</p><strong>{kpis.active_users || 0}</strong></div>
        <div className="kpi-card"><p>Истекуваат претплати (7 дена)</p><strong>{kpis.expiring_in_7_days || 0}</strong></div>
        <div className="kpi-card"><p>MRR / месечен приход</p><strong>{Number(kpis.mrr || 0).toFixed(2)} MKD</strong></div>
        <div className="kpi-card"><p>Откажани претплати (овај месец)</p><strong>{kpis.cancelled_this_month || 0}</strong></div>
        <div className="kpi-card"><p>Нови корисници (30 дена)</p><strong>{kpis.new_users_30_days || 0}</strong></div>
      </div>
      )}
      

      {message && (
        <div className={`message ${message.includes('✓') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      {/* Reported Issues Modal */}
      {isReportedIssuesModalOpen && <ReportedIssuesModal />}
      {/* Only show users section */}
      {activeTab === 'users' && (
        <div className="users-section">
          <h2>Управување со корисници</h2>
          <p className="section-description">
            Прегледај ги сите корисници и нивните линкови за закажување
          </p>
          <div className="admin-top-row">
            <div className="add-user-form">
              <h3>Додај нов корисник</h3>
              <form onSubmit={handleAddUser}>
                  <input
                    type="text"
                    name="new-name"
                    placeholder="Име"
                    value={newUser.name}
                    onChange={e => setNewUser({ ...newUser, name: e.target.value })}
                    required
                    autoComplete="off"
                  />
                  <input
                    type="text"
                    name="new-phone"
                    placeholder="Телефонски број"
                    value={newUser.phone}
                    onChange={e => setNewUser({ ...newUser, phone: e.target.value })}
                    required
                    autoComplete="off"
                  />
                  <input
                    type="email"
                    name="new-email"
                    placeholder="Е-пошта"
                    value={newUser.email}
                    onChange={e => setNewUser({ ...newUser, email: e.target.value })}
                    required
                    autoComplete="off"
                  />
                  <input
                    type="password"
                    name="new-password"
                    placeholder="Лозинка"
                    value={newUser.password}
                    onChange={e => setNewUser({ ...newUser, password: e.target.value })}
                    required
                    autoComplete="new-password"
                  />
                  <button type="submit" className="btn-success">Додај корисник</button>
              </form>
              {addUserMessage && (
                <div className="message success">{addUserMessage}</div>
              )}
            </div>

            <div className="manage-plans-card">
              <h3>{editingPlanId ? 'Измени план' : 'Додај / Управувај со планови'}</h3>
              <form onSubmit={handleSubmitPlan} className="plan-form">
                <input
                  type="text"
                  placeholder="Име на план"
                  value={planForm.name}
                  onChange={(e) => setPlanForm({ ...planForm, name: e.target.value })}
                  required
                />
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Цена по месец (MKD)"
                  value={planForm.monthly_price}
                  onChange={(e) => setPlanForm({ ...planForm, monthly_price: e.target.value })}
                  required
                />
                <input
                  type="text"
                  placeholder="Опис (опционално)"
                  value={planForm.description}
                  onChange={(e) => setPlanForm({ ...planForm, description: e.target.value })}
                />
                <div className="plan-form-actions">
                  <button type="submit" className="btn-success">
                    {editingPlanId ? 'Зачувај' : 'Додај план'}
                  </button>
                  {editingPlanId && (
                    <button
                      type="button"
                      className="btn-subscription"
                      onClick={() => {
                        setEditingPlanId(null);
                        setPlanForm({ name: '', monthly_price: '', description: '' });
                      }}
                    >
                      Откажи
                    </button>
                  )}
                </div>
              </form>

              <div className="plans-list">
                {plans.map((plan) => (
                  <div key={plan.id} className="plan-row">
                    <div>
                      <p><strong>{plan.name}</strong></p>
                      <p>{Number(plan.monthly_price || 0).toFixed(2)} MKD / месец</p>
                    </div>
                    <div className="plan-row-actions">
                      <button type="button" className="btn-subscription" onClick={() => handleEditPlan(plan)}>Измени</button>
                      <button
                        type="button"
                        className={`btn-subscription ${plan.is_active ? 'btn-subscription-danger' : 'btn-subscription-resume'}`}
                        onClick={() => handleTogglePlanActive(plan)}
                      >
                        {plan.is_active ? 'Деактивирај' : 'Активирај'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="users-table">
            <div className="users-table-toolbar">
              <input
                type="text"
                value={userSearchQuery}
                onChange={(e) => setUserSearchQuery(e.target.value)}
                placeholder="Пребарај по име, е-пошта, телефон или ID"
                className="users-search-input"
              />
              <select
                value={subscriptionFilter}
                onChange={(e) => setSubscriptionFilter(e.target.value)}
                className="users-filter-select"
              >
                <option value="all">Претплата: Сите</option>
                <option value="active">Активна</option>
                <option value="paused">Паузирана</option>
                <option value="cancelled">Откажана</option>
                <option value="none">Без претплата</option>
              </select>
              <button
                type="button"
                className="btn-subscription users-clear-filters"
                onClick={() => {
                  setUserSearchQuery('');
                  setSubscriptionFilter('all');
                }}
              >
                Исчисти
              </button>
              <span className="users-count-pill">{displayedUsers.length} корисници</span>
            </div>

            <table className="users-grid-table">
              <thead>
    <tr>
      <th className="col-user">Корисник</th>
      <th className="col-report">Извештај</th>
      <th className="col-link">Линк</th>
      <th className="col-subscription">Претплата</th>
      <th className="col-payment">Плаќање</th>
      <th className="col-actions">Акции</th>
    </tr>
  </thead>
              <tbody>
                {displayedUsers.map((user) => (
                  <tr key={user.id}>
                    <td className="col-user">
  <div className="user-main">
    {user.name} <span className="user-id">#{user.id}</span>
  </div>
  <div className="user-sub" title={user.email}>{user.email}</div>
  <div className="user-sub" title={user.phone}>{user.phone || '—'}</div>
</td>
                    <td className="cell-report">
                      <label className="toggle-switch-admin">
                        <input
                          type="checkbox"
                          checked={user.has_monthly_report || false}
                          onChange={() => handleToggleMonthlyReport(user.id, user.has_monthly_report)}
                        />
                        <span className="toggle-slider-admin"></span>
                      </label>
                    </td>
                    <td className="cell-link">
                      <button 
                        className="btn-copy-link"
                        onClick={() => copyBookingLink(user)}
                        title={getBookingLink(user)}
                      >
                        📋 Копирај линк
                      </button>
                    </td>
                    <td className="cell-subscription">
  <div className="subscription-card">
    {renderSubscriptionCell(user, user.latestSubscription)}
  </div>
</td>
<td
  className="col-payment"
  onClick={() => openPaymentModal(user)}
  style={{ cursor: 'pointer' }}
>
  {(() => {
    const status = String(user.payment_status || '').toLowerCase();

    if (status === 'paid') {
      return <span className="payment-badge paid">PAID</span>;
    }

    if (status === 'overdue') {
      return <span className="payment-badge overdue">OVERDUE</span>;
    }

    return <span className="payment-badge unpaid">UNPAID</span>;
  })()}
</td>
                    <td className="cell-actions">
                      <div className="user-actions-stack">
                        <button
                          className="btn-reset-user-password"
                          onClick={() => openResetPasswordConfirm(user)}
                        >
                          Ресет лозинка
                        </button>
                        <button
                          className="btn-delete-user"
                          onClick={() => openDeleteUserConfirm(user)}
                        >
                          🗑️ Избриши
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {activeTab === 'activity' && (
  <>
    <div
  className="admin-insights-trigger"
  onClick={() => setIsInsightsModalOpen(true)}
>
      <span className="admin-insights-trigger-title">Увид на корисници</span>
      <span className="admin-insights-trigger-subtitle">
        {userInsights.length} корисници • услуги, клиенти и месечен раст
      </span>
    </div>
  </>
)}

{activeTab === 'sessions' && (
  <div
    className="admin-insights-trigger"
    onClick={() => setIsSessionsModalOpen(true)}
  >
    <span className="admin-insights-trigger-title">Сесии и уреди</span>
    <span className="admin-insights-trigger-subtitle">
      {sessions.length} сесии • детали за уред и IP
    </span>
  </div>
)}
      {isSessionsModalOpen && (
        <div className="admin-modal-overlay" onClick={() => setIsSessionsModalOpen(false)}>
          <div className="admin-modal admin-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="admin-insights-modal-head">
              <div>
                <h3>Сесии и уреди</h3>
                <p>Преглед на сите активни и одјавени сесии, со детали за уред и IP.</p>
              </div>
              <button type="button" className="btn-subscription" onClick={() => setIsSessionsModalOpen(false)}>Затвори</button>
            </div>
            <div className="admin-sessions-filters">
              <select
                value={sessionFilters.user_id}
                onChange={(e) => setSessionFilters((prev) => ({ ...prev, user_id: e.target.value }))}
              >
                <option value="">Сите корисници</option>
                {users.filter((u) => u.role !== 'admin').map((user) => <option key={user.id} value={user.id}>{user.name}</option>)}
              </select>
              <select
                value={sessionFilters.status}
                onChange={(e) => setSessionFilters((prev) => ({ ...prev, status: e.target.value }))}
              >
                <option value="active">Активни</option>
                <option value="revoked">Одјавени</option>
                <option value="all">Сите</option>
              </select>
              <button type="button" className="btn-subscription" onClick={fetchSessions}>Примени</button>
            </div>
            <div className="audit-table-wrap">
              <table className="audit-table insights-table">
                <thead>
                  <tr>
                    <th>Корисник</th>
                    <th>Уред / Browser</th>
                    <th>IP</th>
                    <th>Најавен</th>
                    <th>Последна активност</th>
                    <th>Статус</th>
                    <th>Акција</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((session) => (
                    <tr key={session.id}>
                      <td>
                        <strong>{session.user_name}</strong>
                        <div className="insight-subtext">{session.user_email}</div>
                      </td>
                      <td>
                        <span>{session.user_agent || '-'}</span>
                        <button
                          type="button"
                          className="insight-count-button"
                          onClick={() => setSessionDetailModal(session)}
                        >
                          Детали
                        </button>
                      </td>
                      <td>{session.ip_address || '-'}</td>
                      <td>{new Date(session.created_at).toLocaleString()}</td>
                      <td>{new Date(session.last_seen_at).toLocaleString()}</td>
                      <td>{session.revoked_at ? 'Одјавена' : 'Активна'}</td>
                      <td>
                        {!session.revoked_at && (
                          <button
                            type="button"
                            className="btn-subscription btn-subscription-danger"
                            onClick={() => handleRevokeSession(session.id)}
                          >
                            Revoke
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {sessionDetailModal && (
        <div className="admin-modal-overlay" onClick={() => setSessionDetailModal(null)}>
          <div className="admin-modal admin-modal-medium" onClick={(e) => e.stopPropagation()}>
            <div className="admin-insights-modal-head">
              <div>
                <h3>Детали за уред / сесија</h3>
                <p>Корисник: <strong>{sessionDetailModal.user_name}</strong></p>
              </div>
              <button type="button" className="btn-subscription" onClick={() => setSessionDetailModal(null)}>Затвори</button>
            </div>
            <div className="insight-detail-list-wrap">
              <table className="audit-table insight-detail-table">
                <tbody>
                  <tr><td>Е-пошта</td><td>{sessionDetailModal.user_email}</td></tr>
                  <tr><td>Уред / Browser</td><td>{sessionDetailModal.user_agent || '-'}</td></tr>
                  <tr><td>IP адреса</td><td>{sessionDetailModal.ip_address || '-'}</td></tr>
                  <tr><td>Најавен</td><td>{new Date(sessionDetailModal.created_at).toLocaleString()}</td></tr>
                  <tr><td>Последна активност</td><td>{new Date(sessionDetailModal.last_seen_at).toLocaleString()}</td></tr>
                  <tr><td>Статус</td><td>{sessionDetailModal.revoked_at ? 'Одјавена' : 'Активна'}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {isInsightsModalOpen && (
        <div className="admin-modal-overlay" onClick={() => setIsInsightsModalOpen(false)}>
          <div className="admin-modal admin-modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="admin-insights-modal-head">
              <div>
                <h3>Увид на корисници</h3>
                <p>Преглед на услуги, клиенти и раст споредба со минат месец.</p>
              </div>
              <button type="button" className="btn-subscription" onClick={() => setIsInsightsModalOpen(false)}>Затвори</button>
            </div>
            <div className="audit-table-wrap">
              <table className="audit-table insights-table">
                <thead>
                  <tr>
                    <th>Корисник</th>
                    <th>Услуги</th>
                    <th>Клиенти</th>
                    <th>Термини (месец)</th>
                    <th>Приход (месец)</th>
                  </tr>
                </thead>
                <tbody>
                  {userInsights.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <strong>{item.name}</strong>
                        <div className="insight-subtext">#{item.id} • {item.email || '-'}</div>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="insight-count-button"
                          onClick={() => openInsightDetailModal({
                            type: 'services',
                            userName: item.name,
                            items: item.services,
                          })}
                        >
                          {item.services_count}
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="insight-count-button"
                          onClick={() => openInsightDetailModal({
                            type: 'customers',
                            userName: item.name,
                            items: item.customers,
                          })}
                        >
                          {item.customers_count}
                        </button>
                      </td>
                      <td>
                        <div className="insight-main-value">{item.appointments_this_month}</div>
                        {renderDeltaBadge(item.appointments_delta_vs_last_month)}
                      </td>
                      <td>
                        <div className="insight-main-value">{Number(item.revenue_this_month || 0).toFixed(2)} MKD</div>
                        {renderCurrencyDeltaBadge(item.revenue_delta_vs_last_month)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {insightDetailModal && (
        <div className="admin-modal-overlay" onClick={() => setInsightDetailModal(null)}>
          <div className="admin-modal admin-modal-medium" onClick={(e) => e.stopPropagation()}>
            <div className="admin-insights-modal-head">
              <div>
                <h3>
                  {insightDetailModal.type === 'services' ? 'Услуги' : 'Клиенти'} - {insightDetailModal.userName}
                </h3>
                <p>
                  Вкупно: {insightDetailModal.items.length}
                </p>
              </div>
              <button type="button" className="btn-subscription" onClick={() => setInsightDetailModal(null)}>Затвори</button>
            </div>

            {insightDetailModal.items.length === 0 ? (
              <p className="insight-empty">Нема податоци.</p>
            ) : (
              <div className="insight-detail-list-wrap">
                <table className="audit-table insight-detail-table">
                  <thead>
                    {insightDetailModal.type === 'services' ? (
                      <tr>
                        <th>Услуга</th>
                        <th>Цена</th>
                        <th>Времетраење</th>
                      </tr>
                    ) : (
                      <tr>
                        <th>Име</th>
                        <th>Телефон</th>
                        <th>Е-пошта</th>
                      </tr>
                    )}
                  </thead>
                  <tbody>
                    {insightDetailModal.items.map((entry) => (
                      insightDetailModal.type === 'services' ? (
                        <tr key={`service-${entry.id}`}>
                          <td>{entry.name || '-'}</td>
                          <td>{Number(entry.price || 0).toFixed(2)} MKD</td>
                          <td>{entry.duration || '-'} мин</td>
                        </tr>
                      ) : (
                        <tr key={`customer-${entry.id}`}>
                          <td>{entry.name || `ID ${entry.id}`}</td>
                          <td>{entry.phone || '-'}</td>
                          <td>{entry.email || '-'}</td>
                        </tr>
                      )
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {confirmDialog && (
        <div className="admin-modal-overlay" onClick={closeLifecycleConfirm}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{confirmDialog.title}</h3>
            <p>{confirmDialog.description}</p>
            <div className="admin-modal-actions">
              <button type="button" className="btn-subscription" onClick={closeLifecycleConfirm}>Назад</button>
              <button type="button" className="btn-subscription btn-subscription-danger" onClick={handleConfirmLifecycle}>Потврди</button>
            </div>
          </div>
        </div>
      )}

      {deleteUserDialog && (
        <div className="admin-modal-overlay" onClick={closeDeleteUserConfirm}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Потврда за бришење</h3>
            <p>Дали сте сигурни дека сакате да го избришете корисникот {deleteUserDialog.name}?</p>
            <div className="admin-modal-actions">
              <button type="button" className="btn-subscription" onClick={closeDeleteUserConfirm}>Назад</button>
              <button type="button" className="btn-subscription btn-subscription-danger" onClick={handleConfirmDeleteUser}>Избриши</button>
            </div>
          </div>
        </div>
      )}

      {resetPasswordDialog && (
        <div className="admin-modal-overlay" onClick={closeResetPasswordConfirm}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Потврда за ресет лозинка</h3>
            <p>
              Дали сте сигурни дека сакате да ја ресетирате лозинката за {resetPasswordDialog.name}?
            </p>
            <p>Новата лозинка ќе биде: <strong>12345</strong></p>
            <div className="admin-modal-actions">
              <button type="button" className="btn-subscription" onClick={closeResetPasswordConfirm}>Назад</button>
              <button type="button" className="btn-subscription btn-subscription-danger" onClick={handleConfirmResetPassword}>Ресетирај</button>
            </div>
          </div>
        </div>
      )}

      {selectedPaymentUser && (
  <div className="modal-overlay" onClick={closePaymentModal}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <h3>Плаќање</h3>

      <p style={{ marginTop: '8px' }}>
        <strong>{selectedPaymentUser.name}</strong>
      </p>

      <div style={{ marginTop: '16px' }}>
        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>
          Датум на уплата
        </label>
        <input
          type="date"
          value={paymentForm.date}
          onChange={(e) =>
            setPaymentForm((prev) => ({
              ...prev,
              date: e.target.value
            }))
          }
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '10px',
            border: '1px solid #ddd'
          }}
        />
      </div>

      <div style={{ marginTop: '16px' }}>
        <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600' }}>
          Белешка
        </label>
        <textarea
          value={paymentForm.note}
          onChange={(e) =>
            setPaymentForm((prev) => ({
              ...prev,
              note: e.target.value
            }))
          }
          placeholder="Белешка (опционално)"
          style={{
            width: '100%',
            minHeight: '90px',
            padding: '10px',
            borderRadius: '10px',
            border: '1px solid #ddd',
            resize: 'vertical'
          }}
        />
      </div>

      <div
        style={{
          marginTop: '18px',
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap'
        }}
      >
        <button
          type="button"
          className="btn-subscription btn-subscription-create"
          onClick={async () => {
            setPaidUsers((prev) => ({
              ...prev,
              [selectedPaymentUser.id]: true
            }));

            setPaymentData((prev) => ({
              ...prev,
              [selectedPaymentUser.id]: {
                paid: true,
                date: paymentForm.date,
                note: paymentForm.note
              }
            }));
await updatePaymentInfo(selectedPaymentUser.id, {
  payment_status: 'paid',
  last_payment_date: paymentForm.date || null,
  payment_note: paymentForm.note || null
});
await fetchAdminData({ showLoader: false });
            closePaymentModal();
          }}
        >
          Означи како платено
        </button>

        <button
          type="button"
          className="btn-subscription btn-subscription-danger"
          onClick={async () => {
            setPaidUsers((prev) => ({
              ...prev,
              [selectedPaymentUser.id]: false
            }));

            setPaymentData((prev) => ({
              ...prev,
              [selectedPaymentUser.id]: {
                paid: false,
                date: paymentForm.date,
                note: paymentForm.note
              }
            }));

            await updatePaymentInfo(selectedPaymentUser.id, {
              payment_status: 'unpaid',
              last_payment_date: paymentForm.date || null,
              payment_note: paymentForm.note || null
            });
await fetchAdminData({ showLoader: false });
            closePaymentModal();
          }}
        >
          Означи како неплатено
        </button>

        <button
          type="button"
          className="btn-subscription"
          onClick={closePaymentModal}
        >
          Затвори
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default AdminPanel;
